import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './views/App';
import reportWebVitals from './reportWebVitals';
import Localization from './localization';

const rootElement = document.getElementById('root');

const SAFARI_THEME_COLOR = '#000000';
const SAFARI_BACKGROUND = '#000000';
const IOS_SAFARI_CLASS = 'ios-safari-scroll';

const isIOSSafari = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isIOS = /iP(ad|hone|od)/.test(userAgent);
  const isWebKit = /WebKit/i.test(userAgent);
  const isOtherIOSBrowser = /CriOS|FxiOS|EdgiOS/i.test(userAgent);

  return isIOS && isWebKit && !isOtherIOSBrowser;
};

const forceBlackThemeColor = (): void => {
  let themeMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;

  if (!themeMeta) {
    themeMeta = document.createElement('meta');
    themeMeta.name = 'theme-color';
    document.head.appendChild(themeMeta);
  }

  themeMeta.content = SAFARI_THEME_COLOR;
  document.documentElement.style.background = SAFARI_BACKGROUND;
  document.documentElement.style.backgroundColor = SAFARI_THEME_COLOR;
  document.body.style.background = SAFARI_BACKGROUND;
  document.body.style.backgroundColor = SAFARI_THEME_COLOR;
};

// const config = require('./config/web-site');

const root = ReactDOM.createRoot(
  rootElement as HTMLElement
);
  
Localization.setLanguage();

forceBlackThemeColor();

if (isIOSSafari()) {
  document.documentElement.classList.add(IOS_SAFARI_CLASS);
}

window.addEventListener('pageshow', forceBlackThemeColor);
document.addEventListener('visibilitychange', forceBlackThemeColor);

root.render(
  <React.StrictMode>
    { /*<App config={config} /> */}
    <App />
  </React.StrictMode>
);

reportWebVitals();